import 'portal/Bachelor/static/index.scss';
import 'NoMatch/NoMatch.scss';

import Button from 'portal/Bachelor/components/Button';
import EnterForm from '../components/EnterForm';
import Layout from '../components/Layout';
import LiveGames from 'portal/Bachelor/static/livegames.jpg';
import Login from 'portal/Bachelor/components/Login';
import React from 'react';
import VotingClosed from 'portal/Bachelor/static/ending.png';
import withConfig from 'global/components/HOC/withConfig';

const Home = props => {
	return (
		<>
			<Layout>
				<div className="bachelor-404">
					<img src={LiveGames} style={{ borderRadius: 20 }} className="mb30" />
					<img src={VotingClosed} />
					<p className="mt30" style={{ maxWidth: 720, margin: '0 auto', fontSize: 19 }}>
						The BacheLEAGUE may be over but your winning chances continue with LottoStar!
						<br />
						<br /> Bet now on our Live Games with payouts of up to R5 Million and you could join our lucky winners – who
						have won over R8 Billion to date. Register now to claim your Free Bet.
					</p>
					<a target="_blank" href="https://lottostar.co.za/?aid=league_reg_bonus">
						<Button text="TAKE ME TO LOTTOSTAR" />
					</a>
					<p style={{ maxWidth: 720, margin: '30px auto' }}>
						Free Bets only apply to new registrations. Promo Credits are valid for 48hrs from registration.
					</p>
				</div>
			</Layout>
		</>
	);
};

export default withConfig(Home, {
	slug: 'bachelor'
});
